import { getClientApplicationContext } from '@hc-frontend/core-context';

const insxCloudComLinkRegex = /healthcare-com\.insxcloud\.com/;

export function isInsxCloudComLink(url: URL) {
  return insxCloudComLinkRegex.test(url.hostname);
}

export async function checkInsxCloudComLink(url: URL): Promise<string> {
  const context = getClientApplicationContext(checkInsxCloudComLink);
  const userId = await context.getDomainUserId();
  const sessionId = await context.getDomainSessionId();
  url.searchParams.set('gclid', `${userId}|${sessionId}`);
  return decodeURIComponent(url.href);
}
